(function () {
  function initGallery(root) {
    if (root.dataset.galleryInitialized === 'true') return;
    root.dataset.galleryInitialized = 'true';

    var track = root.querySelector('[data-product-card-gallery-track]');
    var dotsContainer = root.querySelector('[data-product-card-gallery-dots]');
    if (!track || !dotsContainer) return;

    var dots = Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-index]'));
    if (dots.length === 0) return;

    function setActive(index) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    }

    function scrollToIndex(index) {
      var slide = track.children[index];
      if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var index = parseInt(dot.getAttribute('data-index'), 10);
        scrollToIndex(index);
        setActive(index);
      });
      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (type) {
        dot.addEventListener(type, function (event) {
          event.stopPropagation();
        }, { passive: true });
      });
    });

    var scrollTimeout;
    track.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          var trackRect = track.getBoundingClientRect();
          var center = trackRect.left + trackRect.width / 2;
          var closestIndex = 0;
          var closestDistance = Infinity;

          Array.prototype.forEach.call(track.children, function (slide, i) {
            var rect = slide.getBoundingClientRect();
            var slideCenter = rect.left + rect.width / 2;
            var distance = Math.abs(slideCenter - center);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = i;
            }
          });

          setActive(closestIndex);
        }, 80);
      },
      { passive: true }
    );
  }

  function initAll(container) {
    var scope = container && container.querySelectorAll ? container : document;
    scope.querySelectorAll('[data-product-card-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Re-init when sections are re-rendered (theme editor) or new cards are injected dynamically.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-product-card-gallery]')) {
            initGallery(node);
          }
          if (node.querySelectorAll) {
            initAll(node);
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
